import PropTypes from 'prop-types';
import React from 'react';

function prefix(type) {
  switch (type) {
    case 'C':
      return 'Configuração de ';
    case 'I':
      return 'Inclusão de ';
    case 'E':
      return 'Edição de ';
    case 'V':
      return 'Visualização de ';
    case 'M':
      return 'Manutenção de ';
    case 'A':
      return 'Associação de ';
    case 'H':
      return 'Hierarquia de ';
    case 'CP':
      return 'Cópia de';
    case 'B':
      return 'Busca de ';
    default:
      return type;
  }
}

const DDadosTitle = (props) => {
  if (props.title.length > 54) {
    return (
      <h2 className="func-name mb-2" style={{ fontSize: '1.4em' }}>
        {prefix(props.prefix)} {props.title}
      </h2>
    );
  }

  return (
    <h2 className="func-name mb-2">
      {prefix(props.prefix)} {props.title}
    </h2>
  );
};

DDadosTitle.propTypes = {
  prefix: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default DDadosTitle;
